import { render, staticRenderFns } from "./CreateAssistance.vue?vue&type=template&id=3400c4e1&"
import script from "./CreateAssistance.vue?vue&type=script&lang=js&"
export * from "./CreateAssistance.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssistance.vue?vue&type=style&index=0&id=3400c4e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports